import { Loader } from 'lucide-react';

export default function PageLoader() {
    return (
        <div className='fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-[rgba(255,255,255,.2)] text-2xl'>
            <Loader
                size='30px'
                className='mr-2 animate-spin'
            />
            Loading...
        </div>
    );
}
